export const USER_GETPROFILE_REQUEST = 'profile/USER_GETPROFILE_REQUEST';
export const USER_UPDATEPROFILE_REQUEST = 'profile/USER_UPDATEPROFILE_REQUEST';
export const USER_DELETEPROFILE_REQUEST = 'profile/USER_DELETEPROFILE_REQUEST';
export const USER_GETPROFILE_REQUEST_FAIL = 'profile/USER_GETPROFILE_REQUEST_FAIL';
export const USER_GETPROFILE_RESPONSE = 'profile/USER_GETPROFILE_RESPONSE';
export const USER_UPDATEPROFILE_RESPONSE = 'profile/USER_UPDATEPROFILE_RESPONSE';
export const USER_DELETEPROFILE_RESPONSE = 'profile/USER_DELETEPROFILE_RESPONSE';
export const HIDE_MODAL = 'profile/HIDE_MODAL';
